/* eslint-disable no-useless-escape */
let head = {
  noscript: [],
  script: [
    {
      type: 'text/javascript',
      src: '//l.getsitecontrol.com/p43g281w.js',
      body: true
    }
  ]
};

if (process.env.VUE_APP_ZENDESK_ENABLED === 'true') {
  if (!process.env.VUE_APP_ZENDESK_KEY) {
    throw new Error("env 'VUE_APP_ZENDESK_KEY' is required.");
  }

  head.script.push({
    src: `https://static.zdassets.com/ekr/snippet.js?key=${process.env.VUE_APP_ZENDESK_KEY}`,
    id: 'ze-snippet',
    body: true,
    async: true
  });
}

// if (process.env.VUE_APP_GTM_ENABLED === 'true') {
//   if (!process.env.VUE_APP_GTM_ID) {
//     throw new Error("env 'VUE_APP_GTM_ID' is required.");
//   }

//   head.noscript.push({
//     innerHTML: `
//       <iframe
//         src="https://www.googletagmanager.com/ns.html?id=${process.env.VUE_APP_GTM_ID}"
//         height="0"
//         width="0"
//         style="display:none;visibility:hidden"></iframe>
//     `,
//     body: true
//   });

//   const gTagScripts = [
//     {
//       type: 'text/javascript',
//       innerHTML: `
//         window.dataLayer = window.dataLayer || [];
//           function gtag() {
//             dataLayer.push(arguments);
//           }
//           gtag("consent", "default", {
//             ad_storage: "denied",
//             analytics_storage: "denied",
//             functionality_storage: "denied",
//             personalization_storage: "denied",
//             security_storage: "granted",
//             wait_for_update: 500,
//           });
//           gtag("set", "ads_data_redaction", true);
//           gtag("set", "url_passthrough", true);
//         `
//     },
//     {
//       type: 'text/javascript',
//       innerHTML: `
//         (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
//         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
//         j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
//         'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
//         })(window,document,'script','dataLayer','${process.env.VUE_APP_GTM_ID}');
//       `
//     }
//   ];

//   if (process.env.VUE_APP_COOKIEBOT_ENABLED === 'true') {
//     gTagScripts.map((script) => (script['data-cookieconsent'] = 'ignore'));
//   }

//   head.script.push(...gTagScripts);
// }

// if (process.env.VUE_APP_COOKIEBOT_ENABLED === 'true') {
//   if (!process.env.VUE_APP_COOKIEBOT_CBID) {
//     throw new Error("env 'VUE_APP_COOKIEBOT_CBID' is required.");
//   }

//   head.script.push({
//     type: 'text/javascript',
//     id: 'Cookiebot',
//     src: 'https://consent.cookiebot.com/uc.js',
//     'data-cbid': process.env.VUE_APP_COOKIEBOT_CBID,
//     'data-blockingmode': 'auto'
//   });
// }

export default head;
